export const amount = (value) =>
  value == null ||
  String(value).trim() === "" ||
  !Number.isFinite(Number(value))
    ? "—"
    : new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
      }).format(Number(value));
export const orderDate = (value) => {
  if (!value) return "Fecha no disponible";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? "Fecha no disponible"
    : new Intl.DateTimeFormat("es-ES", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(date);
};
export const statusNames = {
  pending: "Pendiente",
  inPreparation: "En preparación",
  prepared: "Preparado",
  inDelivery: "En ruta",
  delivered: "Entregado",
  notDelivered: "Entrega fallida",
  cancelled: "Cancelado",
  returned: "Devuelto",
  abandoned: "Abandonado",
};
export const paymentNames = {
  pending: "Pendiente de pago",
  paid: "Pagado",
  failed: "Pago fallido",
  refunded: "Devuelto",
  partiallyPaid: "Pago parcial",
};
const logNames = {
  pending: "Productos añadidos al carrito",
  peding: "Productos añadidos al carrito",
  inPreparation: "En preparación",
  prepared: "Pedido preparado",
  inDelivery: "En ruta",
  delivered: "Pedido entregado",
  notDelivered: "Entrega fallida",
  returned: "Pedido devuelto",
  cancelled: "Pedido cancelado",
  canceled: "Pedido cancelado",
  abandoned: "Pedido abandonado",
  reactivated: "Pedido reactivado",
  recoveryEmailSent: "Correo de recuperación enviado",
  paymentCompleted: "Pago realizado",
  createdAt: "Pedido creado",
};
export const orderEvents = (log) =>
  Object.entries(log && typeof log === "object" ? log : {})
    .filter(
      ([key, value]) =>
        logNames[key] &&
        typeof value === "string" &&
        value.trim() &&
        Number.isFinite(new Date(value).getTime()),
    )
    .map(([key, date]) => ({ key, date, name: logNames[key] }))
    .sort((a, b) => new Date(a.date) - new Date(b.date));
export const addressText = (address) => {
  if (!address || typeof address !== "object" || Array.isArray(address))
    return "Sin dirección disponible";
  return (
    [
      [address.street, address.number]
        .filter((v) => v != null && v !== "")
        .join(" "),
      [address.floor, address.door, address.block]
        .filter((v) => v != null && v !== "")
        .join(" · "),
      [address.postalCode || address.zipCode, address.city]
        .filter(Boolean)
        .join(" "),
    ]
      .filter(Boolean)
      .join(", ") || "Sin dirección disponible"
  );
};
